import script from "./CategoriesList.vue?vue&type=script&lang=js&setup=true"
export * from "./CategoriesList.vue?vue&type=script&lang=js&setup=true"

import "./CategoriesList.vue?vue&type=style&index=0&id=54c2bfdd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c2bfdd"]])

export default __exports__